<div class="content">
  <div class="hours">
    @for (hour of range(24); track hour) {
      <div class="hour">
        <div class="hour-no">
          <div class="hour-no-2 ion-padding-end">
            {{ hour || "" }}
          </div>
        </div>
        <div class="hour-content"></div>
      </div>
    }
  </div>
  <div class="currentTime">
    <div class="currentTimeMarker" [style.grid-row-start]="getMinutesNow()" [style.grid-row-end]="getMinutesNow()"></div>
  </div>
  <div class="appointments">
    @for (appointment of appointments; track $index) {
      <div class="appointment" [style.grid-row-start]="getMinutes(appointment.start)" [style.grid-row-end]="getMinutes(appointment.end)">
        <div>
          <ion-text>
            <strong>
            {{ appointment.eventNumber}}
            </strong>
            <small>{{ appointment.start | date: "HH:mm" }} - {{ appointment.end | date: "HH:mm" }} / {{ studySpacesService.getRhythmDescription(appointment.rhythmId) }}</small>
          </ion-text>
        </div>
        <div>
          {{ appointment.title }}
        </div>
      </div>
    }
  </div>
</div>
